/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Jinhyoung Jang (jangjh@rsupport.com)
 *
 * @description
 *
 * @created at 2024-10-15 16:43:59
 **/

import { memo, PropsWithChildren, HTMLAttributes } from "react";

import Whiteboard from "./Whiteboard";

type WhiteboardProps = {
	mode?: WhiteboardMode;
	userId: string | undefined;
	zIndex?: number;
	minimizeZIndex?: number;
} & HTMLAttributes<HTMLDivElement>;

console.log("@rfice/whiteboard_0.1.37");

function Main({ userId, zIndex, minimizeZIndex, children, ...rest }: PropsWithChildren<WhiteboardProps>) {
	return (
		<>
			{children}
			<Whiteboard
				userId={userId || ""}
				zIndex={zIndex || 3000}
				minimizeZIndex={minimizeZIndex || 3000}
				{...rest}
			/>
		</>
	);
}

const are_equal = (prev_props: WhiteboardProps, next_props: WhiteboardProps) => {
	return prev_props.userId === next_props.userId;
};

export default memo(Main, are_equal);
